import {
  Flex,
  Text,
  TextInput,
  Paper,
  Stack,
  Button,
  Title,
  Box,
  rem,
} from "@mantine/core";
import { IconTrash, IconSearch, IconCloudCog } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryPos } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";

const DeleteCache = () => {
  const [prefix, setPrefix] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDeleteCache = async () => {
    setIsLoading(true);
    try {
      const res = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/Cache/delete-cache-prefix?prefix=${prefix}`,
      );

      if (res && res.success) {
        NotificationExtension.Success("Hoàn tất xóa cache !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex
      h="92vh"
      align="center"
      justify="center"
      // Nền gradient chuyển màu nhẹ nhàng từ xanh sang tím
      bg="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)"
      m={-15}
    >
      <Paper
        shadow="xl"
        radius="lg"
        p={40}
        withBorder
        w="90%"
        maw={450}
        style={{
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <Stack gap="xl">
          <Box ta="center">
            <Title
              order={1}
              variant="gradient"
              //   gradient={{ from: "indigo", to: "cyan", deg: 45 }}
              style={{ fontSize: rem(34), fontWeight: 900 }}
            >
              Xóa Cache
            </Title>
          </Box>

          <TextInput
            label="Bộ nhớ dọn dẹp"
            placeholder="Nhập bộ nhớ dọn dẹp"
            size="md"
            radius="md"
            leftSection={<IconCloudCog size={18} stroke={1.5} />}
            value={prefix}
            styles={{
              input: {
                "&:focus": {
                  borderColor: "var(--mantine-color-indigo-filled)",
                },
              },
            }}
            disabled={isLoading}
            onChange={(e) => setPrefix(e.currentTarget.value)}
          />

          <Button
            fullWidth
            loading={isLoading}
            disabled={isLoading}
            size="md"
            radius="md"
            leftSection={<IconTrash size={20} />}
            variant="gradient"
            gradient={{ from: "#EA242A", to: "#2A3176", deg: 90 }}
            className="hover-scale" // Bạn có thể thêm css scale nhẹ khi hover
            style={{
              transition: "transform 0.2s ease",
            }}
            // Thêm hiệu ứng click
            onClick={() => handleDeleteCache()}
          >
            Xóa ngay lập tức
          </Button>
        </Stack>
      </Paper>
    </Flex>
  );
};

export default DeleteCache;
